import React from 'react';
import { Container, Box, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const ExecutiveDirector = () => {
  // Custom styled components for specific styles
  const DirectorArea = styled(Box)(({ theme }) => ({
    paddingTop: '90px',
    paddingBottom: '60px',
    backgroundColor: '#f85103',
  }));

  const DirectorSpeechBubble = styled('div')(({ theme }) => ({
    background: '#ffffff',
    position: 'relative',
    padding: '1rem',
    marginBottom: '2rem',
    zIndex: 1,
    border: '2px solid #ccc',
    borderRadius: '10px',
    boxShadow: '0px 0px 10px rgba(0,0,0,0.2)',
    '::before': {
      content: '""',
      position: 'absolute',
      // Adjustments for speech bubble direction
      // left: { md: '-20px', xs: 'calc(50% - 20px)' }, // Center the speech bubble arrow for xs screens
      // top: { md: '20%', xs: '-20px' }, // Adjust top for xs screens
      // transform: { xs: 'translateX(-50%) rotate(45deg)', md: 'rotate(-45deg)' }, // Rotate arrow for xs screens
      // width: '40px',
      // height: '40px',
      // backgroundColor: '#ffffff',
      // border: '2px solid #ccc',
      // borderRadius: '4px',
      // [theme.breakpoints.down('md')]: {
      //   borderBottomColor: '#ffffff', // Ensure compatibility with different screen sizes
      // },

      left: '-80px',
      top: '80px',
      width: '80px',
      border: '5px solid transparent',
      height: '30px',
      background: '#ffffff',
      clipPath: 'polygon(100% 0%, 0% 100%, 100% 100%)',
      [theme.breakpoints.down('md')]: {
        left: '50%',
        top: '-40px',
        transform: 'translateX(-50%)',
        border: '20px solid transparent',
        borderBottomColor: '#ffffff',
      },
    },
  }));

  return (
    <DirectorArea>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', color: '#fff', pb: 4 }}>
          <Typography variant="h3" component="h3" sx={{ mb: 2, color: '#fff' }}>
            Jambo From Our Executive Director
          </Typography>
          <Typography variant="h6" component="div" sx={{ mb: 2 }}>
            DEBBY ROONEY
          </Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
              sx={{
                p: 4,
                '& img': {
                  width: '100%',
                  maxWidth: '400px',
                  height: 'auto',
                  borderRadius: '50%',
                },
              }}
            >
              <img src="assets/img/about/8.jpg" alt="Executive Director" />
            </Box>
          </Grid>
          <Grid item xs={12} md={8}>
            <DirectorSpeechBubble>
              <Typography variant="body1" paragraph>
                When I first visited Kenya in 1991, I fell in love with the people. In 1993, I started BEADS for Education to improve the status of women in Kenya through women's business development and girls' education.
              </Typography>
              <Typography variant="body1" paragraph>
                As an educator, I strongly believe the oft-quoted statement: <br />
                <strong>To educate a girl is to educate a village and ultimately a nation.</strong>
              </Typography>
              <Typography variant="body1" paragraph>
                Our first sponsored girls exemplify this motto, as they graduate from college, marry, and become successful members of their communities.
              </Typography>
              <Typography variant="body1" paragraph>
                It is my great honor to be called "N'goto Entoinye" by our Maasai and Kenyan communities, which means mother of many girls.
              </Typography>
              <Typography variant="body1" paragraph>
                All of the sponsored girls, their families, and I thank you for your kind support.
              </Typography>
              <Typography variant="h5" component="h5">
                DEBBY ROONEY
              </Typography>
              <Typography variant="body1" paragraph>
                BEADS CO-FOUNDER AND EXECUTIVE DIRECTOR
              </Typography>
              <Typography variant="body1" paragraph>
                <i>*Jambo* means hello in Swahili</i>
              </Typography>
            </DirectorSpeechBubble>
          </Grid>
        </Grid>
      </Container>
    </DirectorArea>
  );
};

export default ExecutiveDirector;